"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = track;

var _fetch = babelHelpers.interopRequireDefault(require("fetch"));

function track(objectType, objectId) {
  var experienced = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  (0, _fetch.default)('data/track', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({
      objectType: objectType,
      id: objectId,
      type: experienced ? 'experienced' : 'visited'
    })
  }).then(function () {}).catch(function () {});
}